import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatInterfaceComponent } from './components/chat-interface/chat-interface.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { SuggestedPromptComponent } from './components/suggested-prompt/suggested-prompt.component';
import {SharedModule} from "../shared/shared.module";
import { ChatButtonComponent } from './components/chat-button/chat-button.component';
import {MatButtonModule} from "@angular/material/button";
import { FenceBlockComponent } from './components/fence-block/fence-block.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ToolsComponent } from './components/tools/tools.component';
import { AiRoutingModule } from './ai-routing.module';



@NgModule({
  declarations: [
    ChatInterfaceComponent,
    ChatMessageComponent,
    SuggestedPromptComponent,
    ChatButtonComponent,
    FenceBlockComponent,
    ProductListComponent,
    ToolsComponent
  ],
  exports: [
    ChatInterfaceComponent,
    ChatButtonComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    AiRoutingModule
  ]
})
export class AiModule { }
